"use client";
import { ReactNode, useEffect, useState } from "react";

interface IinputCheckboxProps {
  name?: string;
  defaultValue?: boolean;
  required?: boolean;
}

type IinputCheckboxWithChildProps = IinputCheckboxProps & {
  children: ReactNode;
  text?: undefined;
};

type IinputCheckboxWithTextProps = IinputCheckboxProps & {
  text: string;
  children?: undefined;
};

const InputCheckbox = ({
  text,
  name,
  defaultValue,
  required,
  children,
}: IinputCheckboxWithChildProps | IinputCheckboxWithTextProps) => {
  const [isChecked, setIsChecked] = useState(defaultValue || false);
  const [error, setError] = useState("");

  useEffect(() => {
    setIsChecked(defaultValue || false);
  }, [defaultValue]);

  const handleInvalid = (e: React.InvalidEvent<HTMLInputElement>) => {
    e.preventDefault();

    const message = "Du måste markera detta alternativ för att fortsätta.";

    e.currentTarget.setCustomValidity(message);
    setError(message);

    window.parent.postMessage(
      {
        name: "input-error",
        data: message,
      },
      "*",
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    e.target.setCustomValidity("");
    setError("");
  };

  return (
    <div>
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          value={isChecked ? "true" : "false"}
          className="sr-only peer"
          name={name}
          checked={isChecked}
          onChange={handleChange}
          onInvalid={handleInvalid}
          required={required}
        />

        <div className="relative shrink-0 w-14 h-7 bg-black rounded-full peer peer-checked:after:-translate-x-full peer-checked:after:left-[calc(100%-3px)] after:content-[''] after:absolute after:top-[3.5px] after:start-[3px] after:bg-white-500 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-300 peer-checked:after:bg-green-500 peer-focus:ring-2 peer-focus:ring-[#0260cc] peer-focus:ring-offset-2"></div>

        {text && (
          <span className="ml-4 font-semibold leading-tight">{text}</span>
        )}
        {children && children}
      </label>

      {error && <p className="text-red-700 mt-1 ml-0.5 text-sm">{error}</p>}
    </div>
  );
};

export default InputCheckbox;
